/*
 * サブシステム名：入金
 * 機能名：入金取込明細
 */
import { mapGetters } from 'vuex'
import flowMixin from '@/mixins/flowMixins'

import filter from '@/rahmen/utils/filters'
import modals from '@/ddv2.library/modals'

import DdCustomButton from '@/components/DdCustomButton'
import DdTransparentButton from '@/components/DdTransparentButton'
import DdDialog from '@/views/DEP/D2COMD0120.vue'

const DdCodeTextBox = () => import('@/components/DdCodeTextBox')
const DdCheckbox = () => import('@/components/DdCheckbox')
const DdIconButtonWithTooltip = () => import('@/components/DdIconButtonWithTooltip')
const DdNumericBox = () => import('@/components/DdNumericBox')
const DdSelectItemsPerPage = () => import('@/components/DdSelectItemsPerPage')
const DdSubHeader = () => import('@/components/DdSubHeader')
const DdTextBox = () => import('@/components/DdTextBox')

// 状況の値を設定
const KAKUTEI = '1'
const MIKAKUTEI = '2'
const TAISHOGAI = '3'
// 連携済みの値を設定
const MIRENKEI = '未'
const RENKEIZUMI = '済'
// 預金種目の値を設定
const KBNSHURUICD = 'SFF070'

export default {
  name: 'NyukinTorikomiMeisaiEdit',
  mixins: [flowMixin],
  components: {
    DdCustomButton,
    DdTransparentButton,
    DdDialog,
    DdCheckbox,
    DdCodeTextBox,
    DdIconButtonWithTooltip,
    DdNumericBox,
    DdSelectItemsPerPage,
    DdSubHeader,
    DdTextBox
  },

  data: () => ({
    // ページネイション用
    itemsPerPage: 100,
    page: 1,

    kihon: {},
    rows: [],
    taishogai: false,
    modeKengen: 0,
    nyukinEditDialog: false,
    Kengen: 0,
    readCheck: false,
    recData: {}
  }),
  computed: {
    ...mapGetters({
      viewTitle: 'system/viewTitle',
      helpUseFlg: 'DDMasters/helpUseFlg'
    }),
    filteredRows () {
      return this.rows.map((elem) => {
        // 金額の表示形式変更
        elem.nyukinKingakuDisp = elem.nyukinKingaku ? filter.numericFormatter(elem.nyukinKingaku) : ''
        elem.tatenKinkenKingakuDisp = elem.tatenKinkenKingaku ? filter.numericFormatter(elem.tatenKinkenKingaku) : ''
        // 日付の表示形式変更
        elem.kisanWarekiYmdDisp = elem.kisanWarekiYmd.substr(0, 2) + '/' + elem.kisanWarekiYmd.substr(2, 2) + '/' + elem.kisanWarekiYmd.substr(4, 2)
        elem.kanjoWarekiYmdDisp = elem.kanjoWarekiYmd.substr(0, 2) + '/' + elem.kanjoWarekiYmd.substr(2, 2) + '/' + elem.kanjoWarekiYmd.substr(4, 2)
        // 表示する連携を設定
        elem.renkei = elem.nyukinRenkeiZumiFlg ? RENKEIZUMI : MIRENKEI
        // 連携：済 または 状況：対象外の場合、対象外チェックボックスを非活性
        elem.disableFlg = elem.nyukinRenkeiZumiFlg === true || elem.nyukinTorikomiKbn === TAISHOGAI
        // 状況を設定
        elem.jokyo = elem.codeNm
        return elem
      })
    },
    ...mapGetters({
      msysKubunList: 'DDMasters/msysKubun'
    }),
    isTmpSaveButtonDisplay () {
      return this.modeKengen !== 0
    },
    isDepCreateButtonDisplay () {
      return this.modeKengen !== 0
    }
  },
  created () {
    this.id = this.$route.params.id
    if (this.id === '0') {
      this.id = 0
    }
  },
  mounted () {
    this.initialize()
  },
  beforeRouteUpdate (to, from, next) {
    this.$refs.initialize()
    next()
  },
  methods: {
    getCloneTargetMethod: function () {
      return {
        rows: this.rows
      }
    },
    // 画面遷移
    beforeRouteLeaveByMenu: function (next) {
      const opt = {
        nextCallback: next
      }
      this.preventTransition(opt)
    },
    initialize: function () {
      const self = this
      const opt = {
        loadMasters: ['msyskubun'],
        initializeInputPromise: function () {
          // 入金取込基本を取得
          return new Promise((resolve) => {
            self.HttpClient
              .get(`/api/v1/TrNyukinTorikomiKihon/find?id=${self.id}`)
              .then((data) => {
                self.kihon = data.payload
                self.kihon.impYmd = filter.dateFormatter(self.kihon.impYmd) + ' ' + self.kihon.impHms.substr(0, 5)
                // 預金種目取得
                var yokinShumoku = self.msysKubunList.find((elem) => elem.kbnShuruiCd === KBNSHURUICD && elem.code === self.kihon.yokinShumoku)
                self.kihon.yokinShumokuDisp = yokinShumoku.codeNm
                resolve()
              }).then(() => {
                // 入金取込明細一覧を取得
                return new Promise(resolve => {
                  self.HttpClient
                    .post('/api/v1/VwCD2depd0040/search', { trNyukinTorikomiKihonId: self.id })
                    .then((data) => {
                      // 初期表示で未連携且つ入金先IDが有るものを確定に変更する
                      self.rows = self.initializeSetKakutei(data.payload)

                      resolve()
                    })
                })
              })
          })
        },
        defineHeaderPromise: () => {
          // 入金取込明細一覧ヘッダー取得
          return new Promise(resolve => {
            self.headers = [
              { text: '対象外', value: 'taishogai', sortable: false },
              { text: '入金先設定', value: 'actions', align: 'center', sortable: false },
              { text: '連携', value: 'renkei', sortable: false },
              { text: '状況', value: 'jokyo' },
              { text: '入金先名', value: 'torihikisakiNm' },
              { text: 'No', value: 'nyukinTorikomiMeisaiNo' },
              { text: '振込依頼人コード', value: 'furikomiIraininCd' },
              { text: '振込依頼人名', value: 'furikomiIraininNm' },
              { text: '入金日', value: 'kisanWarekiYmdDisp' },
              { text: '入金額', value: 'nyukinKingakuDisp', align: 'end' },
              { text: 'うち他店金券類', value: 'tatenKinkenKingakuDisp', align: 'end' },
              { text: '照会番号', value: 'shokaiNo' },
              { text: '勘定日', value: 'kanjoWarekiYmdDisp' },
              { text: '仕向銀行名', value: 'shimukeGinkoNm' },
              { text: '仕向銀行店名', value: 'shimukeGinkoShitenNm' },
              { text: '取消区分', value: 'torikesihiKbn' },
              { text: 'EDI情報', value: 'ediInformation' }
            ]
            resolve()
          })
        },
        savedInputRestorePromise: (c) => {
          // ユーザ保存項目の復元
          return new Promise(resolve => {
            self.loadFromCache()
              .then((c) => {
                resolve()
              })
          })
        },
        settingButtonStatePromise: (kengen) => {
          return new Promise(resolve => {
            if (kengen.kengenKbn === '10') {
              // 読取モード
              self.modeKengen = 0
            } else if (kengen.kengenKbn === '20') {
              // 削除不可モード
              self.modeKengen = 1
            } else {
              // フルアクセス
              self.modeKengen = 2
            }

            self.$nextTick(() => {
              document.getElementById('heavy-element').style.display = ''
            })

            resolve()
          })
        }
      }
      self.initializeForViewer(opt)
      console.log('*clone*ii', self.cloneData)
    },
    onReturnButtonClick: function (e) {
      console.log('onReturnButtonClick', e)
      const self = this
      const opt = {
        getTransitionBackParams: function () {
          return {
            actionId: 0,
            param: { id: self.id }
          }
        }
      }
      this.transitionBack(opt)
    },
    onNyukinEditDialogOpen: function (e, item) {
      // 連携：済 または 状況が対象外
      if (item.nyukinRenkeiZumiFlg === true || item.nyukinTorikomiKbn === TAISHOGAI) {
        this.readCheck = true
      } else {
        this.readCheck = false
      }
      this.Kengen = this.modeKengen
      this.recData = item
      this.nyukinEditDialog = true
    },
    onNyukinEditButtonClick: function (item) {
      // 連携：済 または 状況が対象外
      if (item.nyukinRenkeiZumiFlg === true || item.nyukinTorikomiKbn === TAISHOGAI) {
        this.readCheck = true
      } else {
        this.readCheck = false
      }
      this.Kengen = this.modeKengen
      this.recData = item
      this.nyukinEditDialog = true
    },
    onNyukinEditDialogClosed: function (data) {
      this.nyukinEditDialog = false
      if (data === undefined) { return }
      console.log('onNyukinEditDialogClosed', data)
      if (data.renkeiCheck) {
        console.log('★★★', data.messageCd)
        this.setInvalidSummaryMessage(data.messageCd)
      }
    },
    onTmpSaveBtn: function (e) {
      const self = this
      const opt = {
        registerRequestPromise: self.tmpRegister,
        registerResponsePromise: (data) => {
          return new Promise(resolve => {
            self.id = data.payload
            resolve()
          })
        },
        getIdMethod: () => {
          return self.id
        },
        continuousInputInitializePromise: (id) => {
          return new Promise(resolve => {
            this.id = id
            this.transition(1, { id: id }, self.initialize)
            resolve()
          })
        },
        getTransitionBackParams: function () {
          return {
            actionId: 0,
            param: { id: self.id }
          }
        },
        isUpdateModeMethod: function () {
          return self.id !== 0
        }
      }
      this.register(opt)
    },
    tmpRegister: function () {
      var rowData = this.kihon
      rowData.TrNyukinTorikomiMeisaiList = this.rows
      rowData.DepCreateFlg = false
      const f = this.HttpClient.put(`/api/v1/TrNyukinTorikomiKihon/UpdateMulti?id=${this.id}`, rowData)
      return f
    },
    registerValidate: function () {
      return true
    },
    onDepCreateBtn: function (e) {
      const self = this
      const opt = {
        registerRequestPromise: self.depRegister,
        registerResponsePromise: (data) => {
          return new Promise(resolve => {
            self.id = data.payload
            resolve()
          })
        },
        getIdMethod: () => {
          return self.id
        },
        continuousInputInitializePromise: (id) => {
          return new Promise(resolve => {
            this.id = id
            this.transition(1, { id: id }, self.initialize)
            resolve()
          })
        },
        getTransitionBackParams: function () {
          return {
            actionId: 0,
            param: { id: self.id }
          }
        },
        isUpdateModeMethod: function () {
          return self.id !== 0
        }
      }
      // 登録するデータの存在チェック
      var RegistData = self.rows.filter((elem) => {
        // 連携：未 かつ 状況：確定
        return elem.nyukinRenkeiZumiFlg === false && elem.nyukinTorikomiKbn === KAKUTEI
      })
      if (RegistData.length === 0) {
        // 登録データが存在しない場合、エラーメッセージを表示
        this.setInvalidSummaryMessage('COME0018')
        return false
      }
      // 状況：未確定のデータ存在チェック
      var jokyoCheck = self.rows.filter((elem) => {
        // 状況：未確定
        return elem.nyukinTorikomiKbn === MIKAKUTEI
      })
      if (jokyoCheck.length !== 0) {
        // 状況：確定以外のデータが存在する場合、確認メッセージを表示
        modals.showConfirm('DEPQ0001').then((ok) => {
          if (ok) {
            this.register(opt)
          } else {
            return false
          }
        })
      } else {
        this.register(opt)
      }
    },
    depRegister: function () {
      var rowData = this.kihon
      rowData.TrNyukinTorikomiMeisaiList = this.rows
      rowData.DepCreateFlg = true
      const f = this.HttpClient.put(`/api/v1/TrNyukinTorikomiKihon/UpdateMulti?id=${this.id}`, rowData)
      return f
    },
    initializeSetKakutei: function (rows) {
      return rows.map((elem) => {
        if (!elem.nyukinRenkeiZumiFlg && elem.nyukinsakiId && elem.nyukinTorikomiKbn === MIKAKUTEI) {
          elem.nyukinTorikomiKbn = KAKUTEI
          elem.codeNm = '確定'
        }
        return elem
      })
    },
    // ページ操作
    changeItemsPerPage: function (e) {
      console.log('changeItemsPerPage', e)
      this.itemsPerPage = e
      // 子コンポーネントへの反映
      this.$nextTick().then(() => {
        this.$refs.pagination1.syncPagination(this.itemsPerPage, this.page)
        this.$refs.pagination2.syncPagination(this.itemsPerPage, this.page)
      })
    },
    changePage: function (e) {
      this.page = e
      // 子コンポーネントへの反映
      this.$nextTick().then(() => {
        this.$refs.pagination1.syncPagination(this.itemsPerPage, this.page)
        this.$refs.pagination2.syncPagination(this.itemsPerPage, this.page)
      })
    },
    // ダミー
    onDummyFunction: function () {
      this.$emit('dummy')
    }
  }
}
